// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_FinalizaCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /wizard_servicos/finaliza_compromisso
 *
 * Sent by the wizard at checkout. The frontend bundles the FullCalendar
 * event object plus optional operator notes and the orcamento origin.
 *
 * Validation responsibilities:
 *   - require `compromisso.compromisso_id` (row to finalize)
 *   - tolerate any extra fields the calendar/agenda attaches; the model
 *     enforces a column allowlist so unknown fields are silently ignored.
 */
import { registerContract } from './validate'

export interface WizardServicos_FinalizaCompromissoInput {
compromisso: Record<string, unknown>
observacoesOperador?: string
orcamento_origem?: number
}

registerContract('WizardServicos_FinalizaCompromissoInput', {
  compromisso:         { type: 'object',  required: true },
  observacoesOperador: { type: 'string',  required: false },
  orcamento_origem:    { type: 'number',  required: false },
})
